import MessageBusService from './MessageBusService';
import AsyncEvent from './AsyncEvent';

class Auth {
	/*
	 * interval: 600000ms(10분)
	 */
	constructor(interval = 600000) {
		this.msgbus = new MessageBusService(this);
		this.token;
		this.timer;
		this.interval = interval;
	}

	removeAuthToken() {
		const token = this.getToken();
		return this.msgbus.send('org.araqne.msgbus.TokenPlugin.removeToken', {'guid' : token});
	}

	requestAuthToken() {
		return new AsyncEvent((resolve, reject) => {
			const tokenData = 'logdb-auth-token';
			this.msgbus.send('org.araqne.msgbus.TokenPlugin.issueToken', {
				'token_data': tokenData,
			})
			.onSuccess(resp => {
				this.setToken(resp || {});
				resolve(resp);
			})
			.onFailure((m, raw) => reject(m, raw));
		});
	}

	getToken() {
		return this.token ? this.token.token_id : undefined;
	}

	setToken(token) {
		this.token = token;
	}

	intervalRequest() {
		this.timer = setTimeout(() => {
			this.removeAuthToken()
			.onSuccess(() => {
				this.requestAuthToken()
				.onSuccess((token) => {
					// console.log('get new token success', token);
					this.startRequestTimer(this.interval)
				})
				.onFailure((m, raw) => console.log(m, raw));
			})
			.onFailure((m, raw) => console.log(m, raw));
		}, this.interval);
	}

	startRequestTimer() {
		console.log('start request token timer. Interval: ', this.interval)
		this.intervalRequest();
	}

	stopRequestTimer() {
		if(this.timer) {
			console.log('stop request token timer');
			clearInterval(this.timer);
		}
	}
}

export default Auth;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/Auth.js